import React, { useContext } from 'react'
import WhenStep from 'app/React/Components/misc/WhenStep'
import StepLink from 'app/React/Components/Footer/StepLink'
import StepIsValid from 'app/React/Components/misc/StepIsValid'
import PaymentButton from 'app/React/Components/Footer/PaymentButton'
import { stepIsActive } from "app/React/Helpers/StepHelper";
import FooterPrice from "app/React/Components/Footer/FooterPrice";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function FooterNavigation(props) {
  const {
    configurationLinkAvailable,
    currentStep,
    colorSettingId,
    currentEngineTransmission,
    currentVariant,
    order,
    openConfigurationLink,
    strings,
    setOpenConfigurationLink,
  } = useContext(ConfiguratorContext)

  const configurationLinkStrings = strings.configurationLink ?? {}
  const navigationStrings = strings.navigation ?? {
    next: 'Next'
  }

  const stepsObj = currentVariant.steps ?? {}

  const validCurrentSteps = Object.values(stepsObj).filter((step, index) => {
    // Only check for step 2,3,4, because they can have no active settings, based on payment type.
    if ([2, 3, 4].includes(step?.step_id) && !stepIsActive(
      step.settings,
      step?.step_id,
      colorSettingId,
      currentEngineTransmission,
      currentVariant,
      order
    )) {
      return false // There is no active settings
    }

    return true
  })

  const nextStep = validCurrentSteps.find(step => parseInt(step.step_id) > currentStep)

  const onConfiguratorOpenClick = (e) => {
    e.preventDefault()

    setOpenConfigurationLink(!openConfigurationLink)
  }

  return (
    <div className='config-overview-bar__buttons-wrapper'>
      <FooterPrice/>

      <WhenStep step={currentStep}>
        {currentStep != 5 ? (
          <StepIsValid step={currentStep} hideChildren>
            <StepLink step_id={nextStep?.step_id} label={navigationStrings.next} html_id={'next-' + currentStep}/>
          </StepIsValid>
        ) : (
          <div className='config-overview-bar__buttons'>
            <StepIsValid step={5}>
              <PaymentButton/>
            </StepIsValid>

            {configurationLinkAvailable && (
              <a className='configuration-link__button button' onClick={onConfiguratorOpenClick}>
                {configurationLinkStrings.configurationLink}
              </a>
            )}
          </div>
        )}
      </WhenStep>
    </div>
  )
}
